/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Consult } from '../models/Consult';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ConsultService {

    /**
     * Create Consult API Endpoint
     * Create Consult
     * @param xAccessToken 
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static createConsult(
xAccessToken: string,
requestBody: {
method: string;
adviserUserID: string;
hopeDate1: string;
hopeDate2?: string;
hopeDate3?: string;
startupStageID: number;
startupPlanID: number;
startupDescription?: string;
consultDescription?: string;
reservedDate?: string;
meetingUrl?: string;
rejectReason?: string;
cancelReason?: string;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: Consult;
}> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/consult',
            headers: {
                'x-access-token': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * List Consult API Endpoint
     * List Consult
     * @param xAccessToken 
     * @param offset 
     * @param limit 
     * @param area 
     * @param status 
     * @param updatedAt 
     * @param sortOrder 
     * @param orderBy 
     * @returns any successful operation
     * @throws ApiError
     */
    public static listConsult(
xAccessToken: string,
offset?: number,
limit?: number,
area?: string,
status?: string,
updatedAt?: string,
sortOrder?: string,
orderBy?: string,
): CancelablePromise<{
status?: number;
message?: string;
data?: {
consults?: Array<Consult>;
count?: number;
};
}> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/consult',
            headers: {
                'x-access-token': xAccessToken,
            },
            query: {
                'offset': offset,
                'limit': limit,
                'area': area,
                'status': status,
                'updatedAt': updatedAt,
                'sortOrder': sortOrder,
                'orderBy': orderBy,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Get Consult Details API Endpoint
     * Get Consult Details
     * @param xAccessToken 
     * @param consultId ID of consult to return
     * @returns any successful operation
     * @throws ApiError
     */
    public static getConsultDetails(
xAccessToken: string,
consultId: number,
): CancelablePromise<{
status?: number;
message?: string;
data?: Consult;
}> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/consult/{consultID}',
            path: {
                'consultID': consultId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Record not Found`,
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Update Consult API Endpoint
     * Update Consult
     * @param xAccessToken 
     * @param consultId ID of consult to update
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static updateConsult(
xAccessToken: string,
consultId: number,
requestBody: {
method?: string;
adviserUserID?: string;
areaID?: number;
hopeDate1?: string;
hopeDate2?: string;
hopeDate3?: string;
startupStageID?: number;
startupPlanID?: number;
startupDescription?: string;
consultDescription?: string;
reservedDate?: string;
meetingUrl?: string;
rejectReason?: string;
cancelReason?: string;
status: string;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: Consult;
}> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/consult/{consultID}',
            path: {
                'consultID': consultId,
            },
            headers: {
                'x-access-token': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Record not Found`,
                500: `Internal Server error`,
            },
        });
    }

}
